export default __webpack_public_path__ + "static/media/icon-sidebar-elsa.e19e0c09.svg";